import { FormItemController, registerFormItemFactory } from "./FormItemController";
import { SelectController } from "./SelectController";
import { DropdownController } from "./DropdownController";
import { MultiTextController } from "./MultiTextController";
import { FileController } from "./FileController";
import { MultiMediaController } from "./MultiMediaController";
import { CheckboxController } from "./CheckboxController";
import { BoolController } from "./BoolController";
import { MultiCheckController } from "./MultiCheckController";
import { TextController } from "./TextController";

type ControllerFactory = (d: Map<any, any>) => FormItemController;

export class FormControllerRegistry {
    private static readonly _map: Map<string, ControllerFactory> = (() => {
        const m = new Map<string, ControllerFactory>();
        m.set("slct",     (d) => new SelectController(d));
        m.set("mslct",    (d) => new SelectController(d));
        m.set("dropdown", (d) => new DropdownController(d));
        m.set("txtl",     (d) => new TextController(d));
        m.set("txt",      (d) => { d.set("textarea", 1); return new TextController(d); });
        m.set("mtxt",     (d) => new MultiTextController(d));
        m.set("fs",       (d) => new FileController(d));
        m.set("mm",       (d) => new MultiMediaController(d));
        m.set("checkbox", (d) => new CheckboxController(d));
        m.set("bool",     (d) => new BoolController(d));
        m.set("mchk",     (d) => new MultiCheckController(d));
        return m;
    })();

    public static createController(ft: string, data: Map<any, any>): FormItemController | undefined {
        const factory = FormControllerRegistry._map.get(ft);
        return factory ? factory(data) : undefined;
    }
}

// Remplit le slot de FormItemController (casse le cycle — cf. FormItemController).
registerFormItemFactory((ft, data) => FormControllerRegistry.createController(ft, data));
